
export default {
  props: ["pcbanner", "swiperOption"],
};
